@import '~style-sheet-helpers/core.less';
@import '../../../../constants/screen-width-breakpoints.module.less';

.connect-marketplace-modal {
  @media @tablet, @desktop, @widescreen, @ultrawide {
    width: 880px;
    height: 600px;
  }
}

.modal-body {
  height: 100%;
  overflow: hidden;

  @media @mobile {
    height: calc(100vh - 50px);
  }

  div,
  iframe {
    border: 0;
    height: 100%;
    width: 100%;
  }
}
